<template>
  <div v-show="modal" class="dialog">
    <div class="mask"></div>
    <div class="my-modal auto-fixed">
      <div class="my-content ">
        <div class="title">上架学校</div>
        <div class="content">
          <div class="table">
            <Table :columns="tableColumns" border :data="tableData" class="mb-5" max-height="500">
            </Table>
          </div>
          <div class="bottom">
            <Button type="primary" @click="$emit('close')">关闭</Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SelectSchoolModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    school: {
      type: Array,
      default: () => []
    }
  },
  emits: ['close', 'cancel', 'lost'],
  data() {
    return {
      // 是否显示弹窗
      modal: false,
      total: 0,
      tableColumns: [
        {
          type: 'index',
          title: '序号',
          width: 80,
          align: 'center'
        },
        {
          title: '学校名称',
          key: 'name',
          align: 'center'
        }
      ],
      tableData: []
    };
  },
  watch: {
    visible(newVal) {
      this.modal = newVal;
    },
    school(newVal) {
      const arr = newVal.map((item) => {
        return { name: item };
      });
      this.tableData = arr;
    }
  },
  created() {
  },
  methods: {
  }
};
</script>
<style lang="scss" scoped>
// 弹窗
.dialog {
  .mb-5 {
    margin-bottom: 20px;
  }
  .mr-5 {
    margin-right: 20px;
  }
  // 遮盖层
  .mask {
    position: fixed;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    top: 0;
    left: 0;
    z-index: 10000;
  }
  .auto-fixed {
    position: fixed;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    z-index: 20000;
  }
  // 对话框
  .my-modal {
    width: 650px;
    height: 650px;
    // margin: 0 auto;
    display: flex;
    // flex-direction: row;
    // flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    .my-content {
      width: 650px;
      background: #ffffff;
      border-radius: 8px;
      .title {
      background: rgb(247, 248, 250);
      height: 40px;
      padding-left: 20px;
      line-height: 40px;
      font-weight: 600;
      border-radius: 8px;
    }
    .content {
      padding: 20px;
      .table {
        width: 606px;
      }
      .bottom {
        clear: both;
        float: right;
        margin-bottom: 20px;
      }
    }
    .table {
      .search {
        width: 144px;
        margin-right: 8px;
      }
      .page {
        float: right;
      }
    }
    }
  }
}
</style>
